import { render, staticRenderFns } from "./CardLeftPanel.vue?vue&type=template&id=898e4f60&scoped=true&"
import script from "./CardLeftPanel.vue?vue&type=script&lang=js&"
export * from "./CardLeftPanel.vue?vue&type=script&lang=js&"
import style0 from "./CardLeftPanel.vue?vue&type=style&index=0&id=898e4f60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898e4f60",
  null
  
)

export default component.exports